<script lang="ts">
  import { ApiFehler, registrieren } from './api.ts';

  let name = $state('');
  let email = $state('');
  let telefon = $state('');
  // Honeypot: für Menschen unsichtbar (siehe .honigtopf in styles.css).
  // Bots füllen jedes Feld aus, das sie im Markup finden.
  let website = $state('');

  let laeuft = $state(false);
  let fehler = $state<string | null>(null);
  let fertig = $state(false);
  let testLink = $state<string | null>(null);

  async function absenden(ereignis: SubmitEvent): Promise<void> {
    ereignis.preventDefault();
    laeuft = true;
    fehler = null;
    try {
      const antwort = await registrieren({
        name: name.trim(),
        email: email.trim(),
        telefon: telefon.trim() || undefined,
        website: website.trim() || undefined,
      });
      fertig = true;
      testLink = antwort.link ?? null;
    } catch (f) {
      fehler = f instanceof ApiFehler ? f.message : 'Das hat leider nicht geklappt.';
    } finally {
      laeuft = false;
    }
  }
</script>

<div class="formular-karte">
  {#if fertig}
    <div class="formular-erfolg">
      <div class="haken-gross">✓</div>
      <h3>Fast geschafft!</h3>
      <p class="leise">
        Bitte prüfe dein E-Mail-Postfach ({email}). Dort wartet ein Link, mit dem du dein Passwort
        vergibst — danach steht dir dein Kundenbereich offen.
      </p>
      {#if testLink}
        <p class="leise klein">
          Kein Mailversand in dieser Testumgebung konfiguriert — Link zum Testen:<br />
          <a href={testLink}>{testLink}</a>
        </p>
      {/if}
    </div>
  {:else}
    <form onsubmit={absenden}>
      {#if fehler}<p class="formular-fehler">{fehler}</p>{/if}

      <div class="feld">
        <label for="reg-name">Dein Name</label>
        <input id="reg-name" type="text" autocomplete="name" bind:value={name} required />
      </div>

      <div class="feld">
        <label for="reg-email">E-Mail-Adresse</label>
        <input id="reg-email" type="email" autocomplete="email" bind:value={email} required />
      </div>

      <div class="feld">
        <label for="reg-telefon">Telefon (optional)</label>
        <input id="reg-telefon" type="tel" autocomplete="tel" bind:value={telefon} />
      </div>

      <div class="honigtopf" aria-hidden="true">
        <label for="reg-website">Bitte leer lassen</label>
        <input id="reg-website" type="text" tabindex="-1" autocomplete="off" bind:value={website} />
      </div>

      <button type="submit" class="tb-btn-primary gross" disabled={laeuft || !name.trim() || !email.trim()}>
        {laeuft ? 'Einen Moment …' : 'Kostenlos registrieren'}
      </button>

      <p class="leise klein hinweis">
        Kein Paket, kein Tarif, keine Zahlungsdaten — nur dein Zugang zum Kundenbereich. Dein persönlicher Ansprechpartner
        meldet sich anschließend bei dir.
      </p>
    </form>
  {/if}
</div>

<style>
  .hinweis {
    margin: 0.9rem 0 0;
    font-size: 0.85rem;
  }

  button.gross {
    width: 100%;
  }
</style>
